import React from "react"
import styled from "styled-components"
import { theme } from "../style/theme"

const I = styled.i`
    font-family: "Material Icons";
    font-size: ${({ options }) => options.size + "px"};
    color: ${({ options }) => options.color};
    transition: color 0.4s;
    text-transform: none;
    font-weight: 400;
`

export default function Icon(props) {
    //Set default options and override with incoming options
    const defaultOptions = {
        size: 16,
        color: theme.grey,
    }
    const options = {
        ...defaultOptions,
        ...props,
    }
    return (
        <I
            options={options}
            style={props.style}
            className={props.className}
            onClick={props.onClick}
        >
            {props.children}
        </I>
    )
}
